import {Drawer, Select} from "antd";
import React, {useState} from "react";
import {useRecoilValue} from "recoil";
import {mobileState} from "../../state/atoms";
import {CloseOutlined} from "@ant-design/icons";
import './CustomSelect.scss';

interface CustomSelectProps {
  values: string[],
  value: string | null,
  otherValue?: string | null,
  placeholder: string,
  setValue: (s: string) => void,
  setOtherValue?: (s: string) => void;
}

const Option = Select.Option;
export default function CustomSelect({values, placeholder, value, setValue, otherValue, setOtherValue}: CustomSelectProps) {
  const mobile = useRecoilValue(mobileState);
  const [open, setOpen] = useState(false);
  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);

  function onSelectClick(e: React.MouseEvent, mobile: boolean) {
    if (!mobile) return;

    e.preventDefault();
    e.stopPropagation();
    setMobileMenuVisible(!isMobileMenuVisible);
  }

  function onDropdownVisibleChange(o: boolean) {
    if (mobile) {
      setOpen(false);
    } else {
      setOpen(o);
    }
  }

  function onValueSelected(v: string) {
    setValue(v);
    setMobileMenuVisible(false);
  }

  const select = (mobile: boolean = false) => <Select size={"large"} placeholder={placeholder} style={{width: '100%'}} listHeight={300} className={'sel'}
                                                      onSelect={setValue} value={value} onClick={(e) => onSelectClick(e, mobile)}
                                                      open={open} onDropdownVisibleChange={onDropdownVisibleChange}>
    {values.map(it => <Option key={it}>{it}</Option>)}
  </Select>;

  // const otherInput = <Input placeholder={'If other, please specify'} value={otherValue || ''} onChange={e => setOtherValue?.(e.target.value)}/>

  const desktopEl = <div style={{display: 'flex', flexDirection: 'column', rowGap: '12px'}}>
    {select()}
    {/*{value === 'Other' && otherInput}*/}
  </div>;

  const mobileEl = <div className={`custom-mobile-wrapper ${!isMobileMenuVisible ? 'drawer-hidden' : ''}`}>
    {select(true)}
    {/*{value === 'Other' && otherInput}*/}
    <Drawer
      placement={"bottom"}
      visible={isMobileMenuVisible}
      onClose={() => setMobileMenuVisible(false)}
      closeIcon={<CloseOutlined/>}
      className={"mobile-bottom-menu custom-select-drawer"}
      height={"450px"}
      title={<header>{placeholder}</header>}
    >
      <div className={'custom-select'}>
        <section>
          {values.map(it => <span onClick={() => onValueSelected(it)} key={it}>{it}</span>)}
        </section>
      </div>
    </Drawer>
  </div>;

  return mobile ? mobileEl : desktopEl;
}
